'use client';

import { useEffect, useState } from 'react';
import groq from 'groq';
import client from 'client';

import styled from 'styled-components';

import getSanityUrl from 'utils/getSanityUrl';
import { H4 } from 'components/Fonts/Font';

const AlbumBrowserContainer = styled.div`
  display: flex;
  margin: 0px 0 30px 0;
  flex-direction: column;
  @media only screen and (min-width: 1024px) {
    margin: 10px 0 60px 0;
  }
`;

const AlbumContainer = styled.ul`
  display: flex;
  list-style: none;
  margin: 0 -5px;
  padding: 0;
  flex-wrap: wrap;
  @media only screen and (min-width: 768px) {
    flex-wrap: initial;
  }
`;

const AlbumBrowserListItem = styled.li`
  padding: 5px;
  width: calc(50% - 10px);
`;

const AlbumImage = styled.img`
  width: 100%;
`;

const AlbumDescription = styled.div`
  background: ${(props) => props.theme.colors.white};
`;

const AlbumDescriptionContainer = styled.div`
  padding: 10px 10px;
`;

const AlbumTitle = styled.h4`
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 500;
  font-size: 0.8rem;
  margin: 0 0 2px 0;
  line-height: 0.8rem;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.darkGrey};
`;

const AlbumName = styled.h5`
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 0.95rem;
  margin: 0;
  color: ${(props) => props.theme.colors.red};
  font-style: italic;
`;

const AlbumBrowserHeader = styled.header`
  display: flex;
  justify-content: center;
  margin: 20px 0;

  @media only screen and (min-width: 768px) {
    justify-content: inherit;
  }
  @media only screen and (min-width: 1024px) {
    align-items: center;
  }
`;

const query = groq`*[_type == "post"]{
  "artist": artist,
  "albumImage": albumHeader.AlbumImageFront,
  slug
  }
  `;

const AlbumBrowser = ({ slug, currentAlbum }) => {
  const [albums, setAlbums] = useState();
  useEffect(() => {
    const getAlbums = async () => {
      const res = await client.fetch(query, { slug });
      setAlbums(res);
    };

    getAlbums();
  }, [setAlbums, slug]);

  if (albums) {
    const sortedAlbums = albums.filter((el) => el.artist.album !== currentAlbum);
    return (
      <AlbumBrowserContainer>
        <AlbumBrowserHeader>
          <H4>Discover more obsure artists and albums.</H4>
        </AlbumBrowserHeader>
        <AlbumContainer>
          {sortedAlbums.map((el) => (
            <AlbumBrowserListItem key={el.artist.name}>
              <a href={`${process.env.NEXT_PUBLIC_HOST}/indie-unheard/${el.slug.current}`}>
                <AlbumImage
                  src={getSanityUrl(el.albumImage).width(600)}
                  alt={`${el.artist.name}- ${el.artist.album}`}
                />
                <AlbumDescription>
                  <AlbumDescriptionContainer>
                    <AlbumTitle>{el.artist.name}</AlbumTitle>
                    <AlbumName>{el.artist.album}</AlbumName>
                  </AlbumDescriptionContainer>
                </AlbumDescription>
              </a>
            </AlbumBrowserListItem>
          ))}
        </AlbumContainer>
      </AlbumBrowserContainer>
    );
  }

  return null;
};

export default AlbumBrowser;
